import React from "react";

const ActivityIcon = (props:any) => {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.8">
        <path
          d="M4.29953 6.51992C5.53953 4.78992 7.55953 3.66992 9.84953 3.66992C13.6195 3.66992 16.6795 6.72992 16.6795 10.4899C16.6795 14.2499 13.6195 17.3199 9.84953 17.3199C6.07953 17.3199 3.01953 14.2599 3.01953 10.4899C3.01953 10.2799 3.02953 10.0799 3.04953 9.87992"
          stroke={props?.color ?? "black"}
          stroke-miterlimit="10"
        />
        <path
          d="M4.22954 3.58984L4.11954 6.33984C4.10954 6.53984 4.28954 6.70984 4.48954 6.67984L7.00954 6.36984"
          stroke={props?.color ?? "black"}
          stroke-miterlimit="10"
          stroke-linecap="round"
        />
        <path
          d="M10.5499 6.72998V10.85H7.66992"
          stroke={props?.color ?? "black"}
          stroke-miterlimit="10"
          stroke-linecap="round"
        />
      </g>
    </svg>
  );
};

export default ActivityIcon;
